// Compares two FormData objects and returns true if they are equal
export function compareFormData(fd1, fd2) {
  const entries1 = [...fd1.entries()];
  const entries2 = [...fd2.entries()];

  if (entries1.length !== entries2.length) return false;

  for (let i = 0; i < entries1.length; i++) {
    const [key1, value1] = entries1[i];
    const [key2, value2] = entries2[i];

    if (key1 !== key2 || value1 !== value2) return false;
  }

  return true;
}
